import { Link } from "react-router-dom";
import { useAnnouncements } from "@/context/AnnouncementsContext";
import { PriorityBadge } from "@/components/AnnouncementBody";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Megaphone, ArrowRight, LockKey } from "@phosphor-icons/react";

/** Compact dashboard preview of the caller's own active notices. */
export const NoticesCard = () => {
    const { announcements, unread, loading } = useAnnouncements();

    return (
        <Card className="border-[#E2E8F0]" data-testid="notices-card">
            <CardContent className="p-6">
                <div className="flex items-center justify-between mb-5">
                    <div>
                        <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 font-semibold">
                            Communication
                        </div>
                        <h3 className="text-lg font-semibold text-[#1F2A44] flex items-center gap-2"
                            style={{ fontFamily: "Outfit" }}>
                            Notices
                            {unread > 0 && (
                                <Badge className="bg-[#E6002C] text-white border-0" data-testid="notices-card-unread">
                                    {unread} new
                                </Badge>
                            )}
                        </h3>
                    </div>
                    <Megaphone size={22} weight="duotone" className="text-[#0066D9]" />
                </div>

                {loading ? (
                    <div className="text-sm text-slate-400 py-4">Loading…</div>
                ) : announcements.length === 0 ? (
                    <div className="text-sm text-slate-500 py-4">
                        No active notices. New announcements from the office will appear here.
                    </div>
                ) : (
                    <div className="divide-y divide-[#E2E8F0]">
                        {announcements.slice(0, 3).map((a) => (
                            <div key={a.id} className="flex items-center justify-between gap-3 py-3"
                                data-testid={`notices-card-item-${a.id}`}>
                                <div className="min-w-0">
                                    <div className="text-sm font-medium text-[#1F2A44] truncate">
                                        {a.locked ? (
                                            <span className="inline-flex items-center gap-1.5">
                                                <LockKey size={13} /> Private notice
                                            </span>
                                        ) : a.title}
                                    </div>
                                    <div className="text-xs text-slate-500 mt-0.5">
                                        {a.presented_at ? "Seen" : "Unread"}
                                        {a.requires_acknowledgment
                                            ? a.acknowledged_at ? " · Acknowledged" : " · Acknowledgment required"
                                            : ""}
                                    </div>
                                </div>
                                <PriorityBadge priority={a.priority} />
                            </div>
                        ))}
                    </div>
                )}

                <Link to="/notices" data-testid="notices-card-link">
                    <Button variant="outline" className="mt-4 border-[#003366] text-[#003366] hover:bg-slate-50">
                        Open Notices <ArrowRight size={16} className="ml-1" />
                    </Button>
                </Link>
            </CardContent>
        </Card>
    );
};
